"use client";

import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    once: true,
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxOffset = scrollY * 0.05;
  return <section id="contact-hero" ref={ref} className="relative w-full h-[240px] md:h-[280px] lg:h-[320px] max-w-[1400px] mx-auto rounded-[25px] bg-[#0a0a0a] overflow-hidden">
      <div className="relative h-full max-w-[1400px] mx-auto rounded-[25px] overflow-hidden bg-[#0a0a0a]">
        
        {}
        <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/image_12zjjrt8.jpg)] opacity-70" style={{
        transform: `translateY(${parallaxOffset}px)`
      }} />

        {}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/40 to-transparent" />

        <div className="relative z-10 flex h-full flex-col items-center justify-center px-4 transition-all duration-[200ms] ease-out opacity-100 translate-y-0 !rounded-[25px] md:px-6">
          <div className="max-w-4xl text-center space-y-6 px-8 py-12 rounded-lg !text-transparent !opacity-[1] !bg-[rgba(252,252,252,0)]">
            <h1 className="font-display text-white font-bold leading-tight tracking-tight !text-5xl">Services</h1>
            <nav aria-label="breadcrumb" data-slot="breadcrumb">
              <ol data-slot="breadcrumb-list" className="flex flex-wrap items-center gap-1.5 break-words sm:gap-2.5 text-white text-sm font-sans justify-center">
                <li data-slot="breadcrumb-item" className="inline-flex items-center gap-1.5">
                  <Link className="hover:text-foreground transition-colors text-white/90 hover:text-white transition-colors duration-[var(--duration-fast)]" data-slot="breadcrumb-link" to="/HomePage">
                    Home
                  </Link>
                </li>
                <li data-slot="breadcrumb-separator" role="presentation" aria-hidden="true" className="[&>svg]:size-3.5 text-white/60">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-chevron-right" aria-hidden="true">
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </li>
                <li data-slot="breadcrumb-item" className="inline-flex items-center gap-1.5">
                  <span data-slot="breadcrumb-page" role="link" aria-disabled="true" aria-current="page" className="text-white font-normal">Services</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </section>;
}